import { Image } from "primereact/image";
import { Link } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Button } from 'primereact/button';
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { Sidebar } from "primereact/sidebar";
import Layout from "../../../components/common/nav/payoll/nav.component";
// import { MyAccountTable2 } from "../../../components/service/myaccounttable2";
import Editpopup from "../../../components/popup/editpopup";
import sideBar from "../../../assets/images/sidebarright.svg"
import user1 from "../../../assets/images/user1.svg"
import { ValidatePayrollRole } from "../../../helper/validateRole";
import { Auth, DataStore, Predicates, SortDirection } from 'aws-amplify';
import Login from "../../../setup/auth/login.component";
import { InitiateClassifiedWeeklyAbsenceReport, InitiateClassifiedWeeklyAbsenceReportEmployee, InitiateClassifiedWeeklyAbsenceReportEmployeeDetails, Employee, Schools, InitiateClassifiedWeeklyAbsenceReportStatus, ReportsLog, AbsentCode } from "../../../models";
import moment from "moment";
import { GetValueFromArray, graphQLGetAllData, graphQLFindRecordById, ConvertResponseForSelect, fetchGraphqlPaginatedRecords } from "../../../helper/commonfunctions";
import AWS from "aws-sdk";
import awsmobile from "../../../aws-exports";
import { reactLocalStorage } from "reactjs-localstorage";
import ReactFullscreen from 'react-easyfullscreen';
import { FilterMatchMode } from 'primereact/api';
import { Dropdown } from "primereact/dropdown";
import { useReactToPrint } from "react-to-print";
import { Timeline } from 'primereact/timeline';
import handleDateSelect from '../../../helper/convertDateIntoPSTFormat';
import { ProgressSpinner } from 'primereact/progressspinner';
import { API, graphqlOperation } from 'aws-amplify';
import * as mutations from '../../../graphql/mutations';
import * as queries from "../../../graphql/queries";
import { useParams } from "react-router-dom";
import {WAR_CLASSIFIED_STATUS } from '../../../helper/enum';

import CheckboxColumn from '../../../components/reportArchive/CheckboxColumn';
import CheckboxHeader from '../../../components/reportArchive/CheckboxHeader';

export default function WARPayroll() {


    const { newReportId } = useParams();

    let [formHistory, setFormHistory] = useState([]);
	
	let [formHistoryApp, setFormHistoryApp] = useState([]);
	let [formHistoryRej, setFormHistoryRej] = useState([]);
	let [formHistoryClosed, setFormHistoryClosed] = useState([]);
	let [formHistoryResub, setFormHistoryResub] = useState([]);
	
	
	const [selectedRows, setSelectedRows] = useState([]);
	
	
	
    const approveStatusOptions = (product) => {

        switch (product.status) {
            case 'Rejected':
                return 'danger';

            case 'APPROVAL_REJECTED':
                return 'danger';

            case 'Completed':
                return 'success';

            case 'Pending':
                return 'warning';

                case 'Resubmitted & Open':
                    return 'warning';

            case 'Closed':
                return 'success';
            case 'Approved':
                return 'success';

            case 'APPROVAL_ACCEPTED':
                return 'success';

           
            case 'Resubmitted':
                    return 'info';
           

            case 'Submitted':
                return 'info';

            case 'Reviewed & resubmitted':
                return 'info';

            default:
                return null;
        }
    };
	const WARClassifIsSuperadmin = reactLocalStorage.get("WARClassifIsSuperadmin");
    //SET AWS Configuration
    AWS.config.update({
        accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
        secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
        region: process.env.REACT_APP_AWS_Region,
    });
    const [absentCodeList, setAbsentCodeList] = useState([]);

    //*state
    const [activate, setActivate] = useState("");
    const toggleActive = () => {
        setActivate(activate === "actives" ? "" : "actives");
    };
    const [checked, setChecked] = useState(false);
    const [visibleRight, setVisibleRight] = useState(false);
    const [loaderData, setLoaderData] = useState(false);
    const [visible, setVisible] = useState(false);
    const [position, setPosition] = useState('center');
    const [weeklyAbsenceReportSubmitted, setWeeklyAbsenceReportSubmitted] = useState();
    const [weeklyAbsenceReportApproved, setWeeklyAbsenceReportApproved] = useState();
    const [weeklyAbsenceReportRejected, setWeeklyAbsenceReportRejected] = useState();
    const [schoolList, setSchoolList] = useState([]);
    const [noAbsence, setNoAbsence] = useState([]);

    //*List
    const [myaccountt, setProducts] = useState([]);
    const [weeklyAbsenceReports, setWeeklyAbsenceReports] = useState([]);
    const [payollList, setPayrollList] = useState([]);
    const l2Authority = reactLocalStorage.get('loggedUserId');
	
	let jsonData=[{userId:l2Authority,payroll:true}]
	jsonData = JSON.stringify(jsonData)
	
    const [employeeList, setEmployeeList] = useState([]);
    const [reportEmployeeList, setReportEmployeeList] = useState([]);
    const [reportDataLoad, setReportDataLoad] = useState(false);

    const [users, SetUsersList] = useState([]);
    const [reportLogList, SetReportLogList] = useState([]);

    //*state
    const [reportId, setReportId] = useState('');
    const [schoolName, setSchoolName] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [status, setStatus] = useState('');
    const [submittedBy, setSubmittedBy] = useState('');
    const [approvedBy, setApprovedBy] = useState('');
    const [reportLoading, setReportLoading] = useState(true);
    const [payrollStatus, setPayrollStatus] = useState('');
    const [submittedByDate, setSubmittedByDate] = useState("");
    const [approverDate, setApproverDate] = useState('');
    const [payrollDate, setPayrollDate] = useState('');
    const [payrollBy, setPayrollBy] = useState('');



    const [comment, setComment] = useState([]);


    //Validate User Logged In
    const [isAuthenticated, userHasAuthenticated] = useState(true);

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        workDuration: { value: null, matchMode: FilterMatchMode.CONTAINS },
        assigneeName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        schoolName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        submittedOn: { value: null, matchMode: FilterMatchMode.CONTAINS },
        submittedBy: { value: null, matchMode: FilterMatchMode.CONTAINS },
        status: { value: null, matchMode: FilterMatchMode.EQUALS },
    });


    // table configs starts
    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });



    const [statuses] = useState(['open', 'Closed']);

    async function onLoad() {
        try {
            await Auth.currentSession();
            if (!ValidatePayrollRole()) { userHasAuthenticated(false); }
        } catch (e) {
            userHasAuthenticated(false);
        }
    }

    const show = (position) => {
        setPosition(position);
        setVisible(true);
    };

    const TaskStatusSL = (product) => {

        switch (product.status) {
            case 'Rejected':
                return 'danger';

            case 'Closed':
                return 'success';

            case 'Pending for Approval':
                return 'warning';

                case WAR_CLASSIFIED_STATUS.RESUBMITTED_OPEN:
                return 'info';

            case 'Submitted':
                return 'info';

                case 'Resubmitted':
                    return 'info';

            case 'open':
                return 'info';

            default:
                return null;
        }
    };

    const statusItemTemplate = (option) => {
        return <Tag value={option} severity={TaskStatusSL(option)} />;
    };
    const statusRowFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterApplyCallback(e.value)} itemTemplate={statusItemTemplate} placeholder="Select" className="p-column-filter custDropdown" showClear style={{ minWidth: '7rem' }} />
        );
    };

    const TaskStatusSLA = (product) => {
        return <Tag value={product.status} severity={TaskStatusSL(product)}></Tag>;
    };
    const alljobactionContent = (row) => {
        return (
            <div className="flex justify-center w-full gap-2">
                {
                    row.status === 'open'  || row.status === WAR_CLASSIFIED_STATUS.RESUBMITTED_OPEN ?
                        <Link to='' className="py-2 px-2.5" onClick={() => { onClickPopup(row); setVisibleRight(true); }}><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link> :
                        row.status === 'Closed' || row.status === WAR_CLASSIFIED_STATUS.RESUBMITTEDBYINT ?
                            <Link to='' className="py-2 px-2.5" onClick={() => { show('right'); onClickPopup(row); }}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                            row.status === 'Rejected' ?
                                <Link to='' className="py-2 px-2.5" onClick={() => { show('right'); onClickPopup(row); }}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                                null
                }
            </div>
        );
    };


    const getFormHistoryData = async (reportId) => {
        let particulerReportAllTransactionCycleRecord = await graphQLGetAllData("listWARClassifiedTransactionCycles", [{ reportId: { eq: reportId } }]);
        let particulerReportMetaRecord = await graphQLGetAllData("listInitiateClassifiedWeeklyAbsenceReports"
            , [{ id: { eq: reportId } }]
        );

        let formHistory = [];
        if (particulerReportAllTransactionCycleRecord.length > 0 && particulerReportMetaRecord) {
            
			particulerReportAllTransactionCycleRecord = particulerReportAllTransactionCycleRecord.filter(item => item.status !== "PAYROLL_CLOSED")
			particulerReportAllTransactionCycleRecord = particulerReportAllTransactionCycleRecord.sort((a, b) => a.createdAt.localeCompare(b.createdAt));
			
            for (let i = 0; i < particulerReportAllTransactionCycleRecord.length; i++) {
                const employee = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: particulerReportAllTransactionCycleRecord[i].toEmployeeId } }])

                if (i == 0) {
                    const employeeData = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: particulerReportMetaRecord[0].user_id } }])

                    let obj = {
                        status: 'Submitted',
                        empTitle: 'Initiator',
                        empName: employeeData[0]?.employee_name,
                        date: handleDateSelect(particulerReportMetaRecord[0].createdAt)

                    }
                    formHistory.push(obj);
                }
				
				if (particulerReportAllTransactionCycleRecord[i].status === WAR_CLASSIFIED_STATUS.RESUBMITTEDBYINT) {
                    const employeeData = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: particulerReportMetaRecord[0].user_id } }])
                    // const employeeData = await graphQLGetAllData("listEmployees", [{ user_Id: { eq: particulerReportAllTransactionCycleRecord[i].fromEmployeeId } }])

                    // let empTitle = (particulerReportAllTransactionCycleRecord[i].fromEmployeeId == particulerReportMetaRecord[0]?.l1_authority) ? "Approver" :
                    //     (particulerReportAllTransactionCycleRecord[i].fromEmployeeId == particulerReportMetaRecord[0]?.l2_authority) ? "Payroll" : "Initiator";
                    // if(WARClassifIsSuperadmin && particulerReportAllTransactionCycleRecord[i].status == 'Rejected'){
                        let obj = {
                            status: WAR_CLASSIFIED_STATUS.RESUBMITTEDBYINT,
                            empTitle: 'Initiator',
                            empName: employeeData[0]?.employee_name,
                            date: handleDateSelect(particulerReportAllTransactionCycleRecord[i].createdAt)
                        }
                        formHistory.push(obj);
                    // }
                    // else {      
                    //     if(lastPart != 'superadmin'){
                    //         let obj = {
                    //             status: WAR_CLASSIFIED_STATUS.RESUBMITTEDBYINT,
                    //             empTitle: empTitle,
                    //             empName: employeeData[0]?.employee_name,
                    //             date: handleDateSelect(particulerReportAllTransactionCycleRecord[i].createdAt)
                    //         }
                    //     }
                      
                    // }
                   
                }else{
					
                let empTitle = (particulerReportAllTransactionCycleRecord[i].toEmployeeId == particulerReportMetaRecord[0]?.l1_authority) ? "Approver" :
                    (particulerReportAllTransactionCycleRecord[i].toEmployeeId == particulerReportMetaRecord[0]?.l2_authority) ? "Payroll" : "Initiator";
                let name = employee[0].employee_name;

                let obj = {
                    status: (particulerReportAllTransactionCycleRecord[i].status == 'Open') ? 'Pending' :
                        (particulerReportAllTransactionCycleRecord[i].status == 'Rejected') ? 'Rejected' :
                            (particulerReportAllTransactionCycleRecord[i].status == 'Resubmit') ? 'Reviewed & resubmitted'
                                : particulerReportAllTransactionCycleRecord[i].status,
                    // status: particulerReportAllTransactionCycleRecord[i].status,
                    empTitle: empTitle,
                    empName: name,
                    date: (particulerReportAllTransactionCycleRecord[i].status == 'Open') ? '-' : handleDateSelect(particulerReportAllTransactionCycleRecord[i].createdAt)

                }
                formHistory.push(obj);

                console.log("objobj:-", obj);
				}

            }

        }
        setFormHistory(formHistory)
		
		
		let formHistoryApp = formHistory.filter(item=>item.status === "Approved")
		setFormHistoryApp(formHistoryApp)
		
		let formHistoryRej = formHistory.filter(item=>item.status === "Rejected")
		setFormHistoryRej(formHistoryRej)
		
		let formHistoryResub = formHistory.filter(item=>item.status === WAR_CLASSIFIED_STATUS.RESUBMITTEDBYINT)
		setFormHistoryResub(formHistoryResub)
		
		let formHistoryClosed = formHistory.filter(item=>item.status === "Closed")
		setFormHistoryClosed(formHistoryClosed)
		
    }

    //* onclick popup
    const onClickPopup = async (requestData) => {
        setReportDataLoad(false)
        setReportId(requestData.id);
        setComment(requestData.comment);
        loadReportLogs(requestData.id);
        let fromDate = moment(requestData.from_date, 'YYYY-MM-DD').format('MM/DD/YYYY'); setFromDate(fromDate);
        let toDate = moment(requestData.to_date, 'YYYY-MM-DD').format('MM/DD/YYYY'); setToDate(toDate);
        setSchoolName(requestData.schoolName); setStatus(requestData.status)

        const cognito = new AWS.CognitoIdentityServiceProvider();

        var particularWeeklyAbsenceReport = await graphQLFindRecordById("getInitiateClassifiedWeeklyAbsenceReport", requestData.id)

        /* var particularWeeklyAbsenceReport = await DataStore.query(InitiateClassifiedWeeklyAbsenceReport, (c) =>
            c.id.eq(requestData.id)); */

        let firstApproval;
        let approveName;
        let payrollName;

        if (requestData.user_id) {
            try {
                firstApproval = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: requestData.user_id, }).promise();
                approveName = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: particularWeeklyAbsenceReport.l1_authority, }).promise();
                payrollName = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: particularWeeklyAbsenceReport.l2_authority, }).promise();

            } catch (e) {
            }
        }
        let firstName = firstApproval.UserAttributes.find(attr => attr.Name === "custom:firstName")?.Value;
        let lastName = firstApproval.UserAttributes.find(attr => attr.Name === "custom:lastName")?.Value;
        let fullName = firstName + " " + lastName;

        let approveNameF = approveName ? approveName.UserAttributes.find(attr => attr.Name === "custom:firstName")?.Value + " " + approveName.UserAttributes.find(attr => attr.Name === "custom:lastName")?.Value : ""

        let payrollNameF = payrollName ? payrollName.UserAttributes.find(attr => attr.Name === "custom:firstName")?.Value + " " + payrollName.UserAttributes.find(attr => attr.Name === "custom:lastName")?.Value : ""


        setSubmittedBy(fullName);

        //get particular report ids data

        // let array = [
        //     { status: 'Submitted', empTitle: 'Initiator', empName: fullName, icon: 'pi pi-shopping-cart', color: '#9C27B0', image: 'game-controller.jpg' },
        //     { status: (particularWeeklyAbsenceReport?.approver_status == 'APPROVAL_ACCEPTED') ? 'Approved' : 'Pending', empTitle: `${'Approver ' + approveNameF}`, icon: 'pi pi-cog', color: '#673AB7' },
        //     // { status: 'Shipped', date: 'L2 Authority', icon: 'pi pi-shopping-cart', color: '#FF9800' },
        //     { status: (particularWeeklyAbsenceReport?.payroll_status == 'PAYROLL_ACCEPTED') ? 'Closed' : "Pending", empTitle: `${'Payroll ' + payrollNameF}`, icon: 'pi pi-check', color: '#607D8B' }

        //     // { status: (particularWeeklyAbsenceReport?.payroll_status == 'PAYROLL_ACCEPTED') ? particularWeeklyAbsenceReport.payroll_status : "Pending", date: `${'Payroll ' + payrollNameF }`, icon: 'pi pi-check', color: '#607D8B' }
        // ];
        // setEvents(array);

        getFormHistoryData(requestData?.id);
        //------------------------------

        if (requestData.approver_by !== null) {
            let firstApproval2;
            if (requestData.approver_by) {
                try {
                    firstApproval2 = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: requestData.approver_by, }).promise();
                } catch (e) {
                }
            }
            let firstName2 = firstApproval2.UserAttributes.find(attr => attr.Name === "custom:firstName")?.Value;
            let lastName2 = firstApproval2.UserAttributes.find(attr => attr.Name === "custom:lastName")?.Value;
            let fullName2 = firstName2 + " " + lastName2;
            setApprovedBy(fullName2);

        }


        if (requestData.payroll_by !== null) {
            let firstApproval2;
            if (requestData.payroll_by) {
                try {
                    firstApproval2 = await cognito.adminGetUser({ UserPoolId: awsmobile.aws_user_pools_id, Username: requestData.payroll_by, }).promise();
                } catch (e) {
                }
            }
            let firstName2 = firstApproval2.UserAttributes.find(attr => attr.Name === "custom:firstName")?.Value;
            let lastName2 = firstApproval2.UserAttributes.find(attr => attr.Name === "custom:lastName")?.Value;
            let fullName2 = firstName2 + " " + lastName2;
            setPayrollBy(fullName2);
        }

        let currentDateTime = moment();
        currentDateTime = moment(currentDateTime).toISOString();

        if (requestData.approver_date_time || requestData.payroll_date_time || requestData.createdAt
        ) {
            let initiateDateTime = requestData.createdAt ? handleDateSelect(requestData.createdAt) : handleDateSelect(currentDateTime);
            setSubmittedByDate(initiateDateTime);
            let approverDateTime = requestData.approver_date_time ? handleDateSelect(requestData.approver_date_time) : null
            setApproverDate(approverDateTime);
            let payrollDateTime = requestData.payroll_date_time ? handleDateSelect(requestData.payroll_date_time) : null
            setPayrollDate(payrollDateTime);
            // let initiateDateTime = requestData.createdAt ? moment(requestData.createdAt, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YYYY, hh:mm A") : null
            // setSubmittedByDate(initiateDateTime);
            // let approverDateTime = requestData.approver_date_time ? moment(requestData.approver_date_time, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YYYY, hh:mm A") : null
            // setApproverDate(approverDateTime);
            // let payrollDateTime = requestData.payroll_date_time ? moment(requestData.payroll_date_time, 'YYYY-MM-DD HH:mm:ss').format("MM/DD/YYYY, hh:mm A") : null
            // setPayrollDate(payrollDateTime);
        }

        if (requestData.payroll_status !== null) { setPayrollStatus(requestData.payroll_status); }

        if (requestData.comment !== null) { setComment(requestData.comment); }

        if (requestData.id) {
            let newResponse = [];

            var employeeResponses = await graphQLGetAllData("listInitiateClassifiedWeeklyAbsenceReportEmployees", [{ initiate_classified_weekly_absence_report_id: { eq: requestData.id } }])

            /* var employeeResponses = await DataStore.query(InitiateClassifiedWeeklyAbsenceReportEmployee, (c) => c.initiate_classified_weekly_absence_report_id.eq(requestData.id)); */

            if (employeeResponses.length > 0) {
                setNoAbsence([])
                for (let index = 0; index < employeeResponses.length; index++) {
                    const item = employeeResponses[index];
                    let employeeName;
                    let substitutedEmployeeName;

                    if (item.employee_id) {
                        let employeeData = await getEmployeeResponse(item.employee_id);
                        if (employeeData) {
                            employeeName = employeeData.employee_name;
                        } else {
                            employeeName = "-";
                        }
                    } else {
                        employeeName = "-";
                    }

                    /* var employeeDetailsResponses = await DataStore.query(
                        InitiateClassifiedWeeklyAbsenceReportEmployeeDetails,
                        (c) => c.initiate_classified_weekly_absence_report_employee_id.eq(item.id)
                    ); */

                    var employeeDetailsResponses = await graphQLGetAllData("listInitiateClassifiedWeeklyAbsenceReportEmployeeDetails", [{ initiate_classified_weekly_absence_report_employee_id: { eq: item.id } }])

                    for (let i = 0; i < employeeDetailsResponses.length; i++) {
                        const detailItem = employeeDetailsResponses[i];

                        let substitutedEmployeeName = "";
                        if (detailItem.substitute_emp_id) {
                            let substituteEmployeeData = await getEmployeeResponse(detailItem.substitute_emp_id);
                            if (substituteEmployeeData) {
                                substitutedEmployeeName = substituteEmployeeData.employee_name;
                            } else {
                                substitutedEmployeeName = "-";
                            }
                        } else {
                            substitutedEmployeeName = "-";
                        }

                        let absentCodeName = "";
                        // let absentCodeResponses = await DataStore.query(AbsentCode, detailItem.absent_code_id);

                        let absentCodeResponses = await graphQLFindRecordById("getAbsentCode", detailItem.absent_code_id)

                        console.log(absentCodeResponses.code);
                        if (absentCodeResponses) {
                            absentCodeName = absentCodeResponses.code;
                        } else {
                            absentCodeName = "-";
                        }

                        let absent_date = moment(detailItem.absent_date).format("MM/DD/YYYY");

                        newResponse.push({
                            "employeeName": employeeName,
                            "absent_date": absent_date,
                            "absent_code_id": absentCodeName,
                            "substitutedEmployeeName": substitutedEmployeeName,
                            "partial_hour": detailItem.partial_hour,
                            "partial_min": detailItem.partial_min,
                            "is_full_day": detailItem.is_full_day,
                        });
                    }

                    if (index === employeeResponses.length - 1) {

                        newResponse = newResponse.sort((a, b) => (a.absent_date).localeCompare(b.absent_date));
                        newResponse = newResponse.sort((a, b) => (a.employeeName?.toLowerCase() ?? "").localeCompare(b.employeeName?.toLowerCase() ?? ""));

                        const sortedNames = [...newResponse].sort((b, a) => {
                            // Split names into first and last name
                            /* const lastNameA = a.employeeName.split(' ')[1];
                            const lastNameB = b.employeeName.split(' ')[1];

                            // Compare last names
                            if (lastNameA !== lastNameB) {
                                return lastNameA.localeCompare(lastNameB);
                            } else {
                                // If last names are the same, compare first names
                                const firstNameA = a.employeeName.split(' ')[0];
                                const firstNameB = b.employeeName.split(' ')[0];

                                if (firstNameA !== firstNameB) {
                                    return firstNameA.localeCompare(firstNameB);
                                } else {
                                    // If first names are the same, compare dates (assuming dates are in YYYY-MM-DD format)
                                    const dateA = new Date(a.absent_date);
                                    const dateB = new Date(b.absent_date);

                                    return dateA - dateB;
                                }
                            } */
                        });


                        // newResponse = newResponse.sort((a, b) => {
                        // const dateA = new Date(a.absent_date);
                        // const dateB = new Date(b.absent_date);
                        // return dateA - dateB;
                        // });
                        setReportEmployeeList(sortedNames);
                        setReportDataLoad(true)
                    }
                }



            } else {
                setReportEmployeeList([])
                setReportDataLoad(true)
                setNoAbsence([1])
            }
        }
    }

    //*get getEmployeeResponse
    const getEmployeeResponse = (id) => {
        let _employeeList = [...employeeList];
        var returnRecord = _employeeList.find(o => o.id === String(id));
        if (returnRecord !== null && returnRecord !== undefined) { return returnRecord; } else { return null; }
    }

    //*get getEmployeeResponse
    const getUserResponse = (id) => {
        let _userList = [...users];
        let getEmployeeResponse = _userList.filter((item) => item.Username === id)
        let firstName = GetValueFromArray(getEmployeeResponse[0].Attributes, "custom:firstName");
        let lastName = GetValueFromArray(getEmployeeResponse[0].Attributes, "custom:lastName");
        let fullName = firstName + " " + lastName;
        return fullName;
    }

    //*loadAbsenceReport
    const loadAbsenceReport = async () => {

        //Set Weekly Absence Report-Classified List
        // var weeklyAbsenceReport = await DataStore.query(InitiateClassifiedWeeklyAbsenceReport, (c) => c.l2_authority.eq(l2Authority));
        // var weeklyAbsenceReport = await DataStore.query(InitiateClassifiedWeeklyAbsenceReport)

        //var weeklyAbsenceReport = await graphQLGetAllData("listInitiateClassifiedWeeklyAbsenceReports", [{ l2_authority: { eq: l2Authority } }])
        //irrespective of l2
        var weeklyAbsenceReport = await graphQLGetAllData("listInitiateClassifiedWeeklyAbsenceReports")

        //load all users
        let employeeList = await fetchGraphqlPaginatedRecords(
            queries.listEmployees,
            null,
            { field: "employee_name", direction: "asc" },
            3000,
            'listEmployees'
        );

        let employeeListData1 = await graphQLGetAllData("listEmployees")
        let newResponse = [];
       // weeklyAbsenceReport = weeklyAbsenceReport.filter(item => item.approver_status === InitiateClassifiedWeeklyAbsenceReportStatus.APPROVAL_ACCEPTED && item.isSoftDelete !== true)
	    weeklyAbsenceReport = weeklyAbsenceReport.filter(item =>  item.isSoftDelete !== true)
		weeklyAbsenceReport = weeklyAbsenceReport.filter((report) => {
			if(report.payroll_status === WAR_CLASSIFIED_STATUS.RESUBMITTEDBYINT){
				return report;
			}
			else if (report.approver_status === InitiateClassifiedWeeklyAbsenceReportStatus.APPROVAL_ACCEPTED || report.approver_status === InitiateClassifiedWeeklyAbsenceReportStatus.RESUBMITTED_APPROVED) {
				return report;
				
			}
		})
		
//weeklyAbsenceReport = weeklyAbsenceReport.filter(report => report.isArchived !== true).sort((b, a) => a.status_date_time.localeCompare(b.status_date_time));
if(selectedRows.length){
		 weeklyAbsenceReport = weeklyAbsenceReport.filter(item => !selectedRows.includes(item.id));
		setSelectedRows([]);
	}
	
	//Archive report
	weeklyAbsenceReport = weeklyAbsenceReport.filter((report) => {
			  if (report.isArchivedUsers) {
				try {
				  //const jsonObject = JSON.parse(report.isArchivedUsers);
				  let jsonObject = JSON.parse(report.isArchivedUsers);
				  if(jsonObject.length){
				  jsonObject = jsonObject.find(item => item.userId === l2Authority && item?.archiveDesignation === 'Payroll' )
				  
				  //console.log(jsonObject,"jsonObject")
				  if (jsonObject) {
					//return report;
				  }else{
					  return report;
				  }
				  
				  }else{
						return report;
					}
				} catch (error) {
				  console.error('Error parsing isArchivedUsers:', report);
				}
			  } else {
				return report;
			  }
			});

if (weeklyAbsenceReport.length > 0) {
            for (let i = 0; i < weeklyAbsenceReport.length; i++) {

                //if (weeklyAbsenceReport[i].approver_status === InitiateClassifiedWeeklyAbsenceReportStatus.APPROVAL_ACCEPTED) {

                let schoolName = "";
                let workDuration = "";
                let submittedOn = "";
                let status = "";
                let submittedBy = "";
                let submittedUser;

                //*School Name
                if (weeklyAbsenceReport[i].school_id !== null && weeklyAbsenceReport[i].school_id !== undefined) {

                    var schoolResponses = schoolList.find(o => o.id === weeklyAbsenceReport[i].school_id)
                    // var schoolResponses = await DataStore.query(Schools, (c) => c.id.eq(weeklyAbsenceReport[i].school_id));

                    if (schoolResponses) { schoolName = schoolResponses.name; } else { schoolName = ""; }
                } else { schoolName = ""; }

                //*Get user
                let userId = weeklyAbsenceReport[i].user_id;
                //use local emp list
                //const cognito = await new AWS.CognitoIdentityServiceProvider();
                if (userId) {
                    let empName = employeeList.find(o => o.user_Id === userId)
                    //console.log(empName,"empName")
                    if (empName) {
                        submittedBy = empName.employee_name ? empName.employee_name : empName?.lastName + "," + empName?.firstName
                    }

                    // try {
                    // submittedUser = await cognito.adminGetUser({
                    // UserPoolId: awsmobile.aws_user_pools_id,
                    // Username: userId,
                    // }).promise();

                    // let exist = submittedUser ? submittedUser : '';
                    // let firstName = GetValueFromArray(exist.UserAttributes, "custom:firstName");
                    // let lastName = GetValueFromArray(exist.UserAttributes, "custom:lastName");
                    // submittedBy = firstName + " " + lastName
                    // } catch (e) {
                    /////console.log(e)
                    // }
                } else {
                    submittedBy = "-"
                }

                //*Work Duration
                if (weeklyAbsenceReport[i].from_date !== null && weeklyAbsenceReport[i].to_date !== null) {
                    let fromDate = moment(weeklyAbsenceReport[i].from_date, 'YYYY-MM-DD').format('MM/DD/YYYY');
                    let toDate = moment(weeklyAbsenceReport[i].to_date, 'YYYY-MM-DD').format("MM/DD/YYYY");
                    workDuration = fromDate + " - " + toDate
                } else { workDuration = "-" }


                //*submitted On
                //if (weeklyAbsenceReport[i].approver_date_time !== null && weeklyAbsenceReport[i].approver_date_time !== undefined) {
                    submittedOn = weeklyAbsenceReport[i].approver_date_time !== null ? weeklyAbsenceReport[i].approver_date_time : weeklyAbsenceReport[i].status_date_time;
				//submittedOn = weeklyAbsenceReport[i].status_date_time;
			   //} else { submittedOn = "-" }
				let hideAssignee = '';
                //if (weeklyAbsenceReport[i].payroll_status !== InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_ACCEPTED && weeklyAbsenceReport[i].payroll_status !== InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_REJECTED) {
                 if (weeklyAbsenceReport[i].payroll_status ===  null || weeklyAbsenceReport[i].payroll_status === ''){
				 status = "open"
                } else if (weeklyAbsenceReport[i].payroll_status === InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_ACCEPTED) {
                    status = "Closed"
					hideAssignee='-'
                }else if (weeklyAbsenceReport[i].payroll_status === WAR_CLASSIFIED_STATUS.RESUBMITTEDBYINT) {
                    status = WAR_CLASSIFIED_STATUS.RESUBMITTEDBYINT
                }else if (weeklyAbsenceReport[i].payroll_status === InitiateClassifiedWeeklyAbsenceReportStatus.RESUBMITTED_OPEN) {
                    status = WAR_CLASSIFIED_STATUS.RESUBMITTED_OPEN
				}else if (weeklyAbsenceReport[i].payroll_status === InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_REJECTED) {
                    status = "Closed"
					hideAssignee='-'
                }
				

                // && weeklyAbsenceReport[i].approver_remark.length > 20 ? weeklyAbsenceReport[i].approver_remark.substring(0, 20) + "..." : ''

                let assigneeName = "";
				//console.log('weeklyAbsenceReport[i]'+weeklyAbsenceReport[i].id, weeklyAbsenceReport[i])
                //console.log('weeklyAbsenceReport[i]', weeklyAbsenceReport[i].id)
				//console.log('weeklyAbsenceReport[i]'+weeklyAbsenceReport[i].id, i)
                try {
					
                    //let x = employees.filter(u => u.user_Id === substituteCertificateRequestTransactionCycleResponse[i].toEmployeeId);
                    let x = employeeListData1.find(u => {
						
						if (weeklyAbsenceReport[i].approver_status == "APPROVAL_REJECTED" && weeklyAbsenceReport[i].status !== InitiateClassifiedWeeklyAbsenceReportStatus.RESUBMITTEDBYINT) {
                            if (u.user_Id === weeklyAbsenceReport[i].user_id) {
                                return u
                            }
                        }else if (weeklyAbsenceReport[i].approver_status === "RESUBMITTED_REJECTED" ) {
                            if (u.user_Id === weeklyAbsenceReport[i].user_id) {
                                return u
                            }
                        }else{
							
					if (weeklyAbsenceReport[i].approver_status === null) {
                                    if (u.user_Id === weeklyAbsenceReport[i].l1_authority) {
                                        return u
                                    }
                                }else if (weeklyAbsenceReport[i].approver_status === WAR_CLASSIFIED_STATUS.RESUBMITTEDBYINT && (weeklyAbsenceReport[i].approver_by === null || weeklyAbsenceReport[i].approver_by==='' )) {
                  if (u.user_Id === weeklyAbsenceReport[i].l1_authority) {
                    return u;
                  }
                }else if (weeklyAbsenceReport[i].payroll_status === null) {
                            if (u.user_Id === weeklyAbsenceReport[i].l2_authority) {
                                return u
                            }
                        }else if(weeklyAbsenceReport[i].payroll_by !== null ){
							if (u.user_Id === weeklyAbsenceReport[i].l2_authority) {
                                return u
                            }
						}else if(weeklyAbsenceReport[i].payroll_by === null && weeklyAbsenceReport[i].approver_by !== null  ){
							if (u.user_Id === weeklyAbsenceReport[i].l2_authority) {
                                return u
                            }
						}
						
						}
                    });

                    let fname = x?.firstName;
                    let lname = x?.lastName;
                    if (fname) {
                        assigneeName = fname;
                    }
                    if (lname) {
                        assigneeName += " " + lname;
                    }
                } catch (e) {
                    console.info(e)
                }

				assigneeName = hideAssignee ? hideAssignee :assigneeName;  
                newResponse.push({
                    "id": weeklyAbsenceReport[i].id, "user_id": weeklyAbsenceReport[i].user_id, "status": status, "school_id": weeklyAbsenceReport[i].school_id, "from_date": weeklyAbsenceReport[i].from_date,"archiveDesignation":"Payroll",
                    "to_date": weeklyAbsenceReport[i].to_date, "status_date_time": weeklyAbsenceReport[i].status_date_time, "approver_status": weeklyAbsenceReport[i].approver_status, "approver_by": weeklyAbsenceReport[i].approver_by, "approver_date_time": weeklyAbsenceReport[i].approver_date_time, "payroll_status": weeklyAbsenceReport[i].payroll_status, "payroll_by": weeklyAbsenceReport[i].payroll_by, "payroll_date_time": weeklyAbsenceReport[i].payroll_date_time,
                    "approver_remark": weeklyAbsenceReport[i].approver_remark, "payroll_remark": weeklyAbsenceReport[i].payroll_remark !== null && weeklyAbsenceReport[i].payroll_remark.length > 20 ? weeklyAbsenceReport[i].payroll_remark.substring(0, 20) + "..." : "-", "schoolName": schoolName, "workDuration": workDuration, "submittedOn": submittedOn, "submittedBy": submittedBy, "createdAt": weeklyAbsenceReport[i].createdAt, "updatedAt": weeklyAbsenceReport[i].updatedAt, "l2authority": weeklyAbsenceReport[i].l2_authority,
                    "comment": weeklyAbsenceReport[i].comment, "assigneeName": assigneeName ? assigneeName : "-"
                })
                //  }
				
				
				

                if (i === weeklyAbsenceReport.length - 1) {
                    setWeeklyAbsenceReports(newResponse)
                    // const weeklyAbsenceReportForApprover = newResponse.filter(obj => obj.l2authority !== null);
                    // console.log('newResponse', newResponse)

                    // let weeklyAbsenceReportForApproverList = weeklyAbsenceReportForApprover   //weeklyAbsenceReportForApprover.filter(obj => obj.l2authority === l2Authority);
                    const sortedData = [...newResponse].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

                    setPayrollList(sortedData)


                    if (newReportId) {
                        // Check if editReportId matches any id in the array
                        const isMatch = sortedData.filter((data) => data.id === newReportId);
                        console.log("isMatch", isMatch)
                        if (isMatch && isMatch[0].status === "open") {
                            onClickPopup(isMatch[0])
                            // setVisible(true);
                            setVisibleRight(true);
                            // show("right");

                        }
                    }

                    setReportLoading(false)
                    //*Pending for Approval
                    /* const submittedCount = newResponse.filter(obj => obj.status === "open");
                    setWeeklyAbsenceReportSubmitted(submittedCount.length)

                    //*Approved
                    const approvedCount = newResponse.filter(obj => obj.status === "Closed")
                    setWeeklyAbsenceReportApproved(approvedCount.length)

                    //* RejectedCount
                    const rejectedCount = newResponse.filter(obj => obj.status === "Rejected")
                    setWeeklyAbsenceReportRejected(rejectedCount.length) */
                }
            }
        } else {
            setReportLoading(false)
        }
    }
	
	
	const TimeSubmitted = rowdata => {
    return rowdata.submittedOn !== null ? <span> {moment(rowdata.submittedOn).format("MM/DD/YYYY")} </span> : "-";
  };

    const loadReportLogs = async (reportId) => {

        //*Report Logs Response
        // var loadReportLogsResponse = await DataStore.query(ReportsLog, (c) => c.report_id.eq(reportId));

        var loadReportLogsResponse = await graphQLGetAllData("listReportsLogs", [{ report_id: { eq: reportId } }])


        if (loadReportLogsResponse.length > 0) {
            let newResponse = [];
            for (let i = 0; i < loadReportLogsResponse.length > 0; i++) {

                let submittedUser;
                let name;
                let ProfilePic;
                let dateTime = moment(loadReportLogsResponse[i].date_and_time).format('HH:mm');
                //*Get user
                let userId = loadReportLogsResponse[i].user_id
                const cognito = await new AWS.CognitoIdentityServiceProvider();
                if (userId) {
                    try {
                        submittedUser = await cognito.adminGetUser({
                            UserPoolId: awsmobile.aws_user_pools_id,
                            Username: userId,
                        }).promise();

                        let exist = submittedUser ? submittedUser : '';
                        let firstName = GetValueFromArray(exist.UserAttributes, "custom:firstName");
                        let lastName = GetValueFromArray(exist.UserAttributes, "custom:lastName");
                        name = firstName + " " + lastName
                        let profilePath = GetValueFromArray(exist.UserAttributes, "picture");
                        // console.log("profilePath-----" + profilePath)
                        if (profilePath !== undefined) {
                            await Storage.get(profilePath)
                                .then(result => {
                                    ProfilePic = result;
                                });
                        } else { ProfilePic = user1; }
                    } catch (e) {
                        //console.log(e)
                    }
                } else {
                }
                newResponse.push({
                    "id": loadReportLogsResponse[i].id,
                    "report_id": loadReportLogsResponse[i].report_id,
                    "comment": loadReportLogsResponse[i].comment,
                    "date_and_time": loadReportLogsResponse[i].date_and_time,
                    "user_id": loadReportLogsResponse[i].user_id,
                    "createdAt": loadReportLogsResponse[i].createdAt,
                    "dateTime": dateTime,
                    "name": name,
                    "ProfilePic": ProfilePic,
                    "updatedAt": loadReportLogsResponse[i].updatedAt,
                })

                if (i === loadReportLogsResponse.length - 1) {
                    SetReportLogList(newResponse);

                }
            }
        } else {
            SetReportLogList([]);
        }

    }
    const GetMasterData = async () => {
        var employeeList = await graphQLGetAllData("listEmployees")
        setEmployeeList(employeeList)

        let SchoolResponses = await graphQLGetAllData("listSchools")
        SchoolResponses = SchoolResponses.sort((a, b) => a.name.localeCompare(b.name));
        setSchoolList(SchoolResponses);
        var AbsentCodeResponses = await graphQLGetAllData("listAbsentCodes")
        AbsentCodeResponses = AbsentCodeResponses.sort((a, b) => a.name.localeCompare(b.name));
        setAbsentCodeList(AbsentCodeResponses)

        setLoaderData(true);
    }

    //*Get Weekly Absence Report-Classified List
    const BindList = async () => {

        /*  var employeeList = await DataStore.query(Employee, Predicates.ALL, {
             sort: s => s.employee_name(SortDirection.ASCENDING)
         }); */

        /* const cognito = new AWS.CognitoIdentityServiceProvider();
        var params =
        {
            UserPoolId: awsmobile.aws_user_pools_id,
            Limit: 60
        };
        cognito.listUsers(params, (err, data) => {
            if (err) {
                console.log(err);
            } else {
                // console.log(data)
                SetUsersList(data.Users);
            }
        }); */

        loadAbsenceReport();
    }

    useEffect(() => {
        GetMasterData();
    }, []);

    useEffect(() => {
        if (loaderData === true) {
            BindList();
            onLoad()
        }
        // MyAccountTable2.getProductsSmall2().then((data) => setProducts(data.slice(0, 9)));
    }, [loaderData]);

    return isAuthenticated ? (
        <>
            <ReactFullscreen>
                {({ ref, onToggle, onExit }) => (
                    <Layout pageTitle="Homepage" activeMenu="Payroll" appId="WEEKLY_ABSENCE_REPORT"
                      reDirectUrl={"/payroll/weekly_absence_report"}
                       IsSuperadmin={WARClassifIsSuperadmin}  
                       reDirectUrlforSA={"/initiator/weekly_absence_report/SuperAdminWARDashboard"} 
                       IsArchive={true} 
                       reDirectUrlforArchive={"/payroll/weekly_absence_report/ArchiveReport"}  >
                        <div className="report-wrapper pt-24 md:pt-28 xl:pt-[2.083vw]">
                            <div className="flex justify-end visible lg:hidden">
                                <Button icon="pi pi-bars" onClick={toggleActive} style={{ color: '#308B90', background: '#ffffff00', border: '1', borderColor: '#308B90', width: '38px', padding: '6px 0', borderRadius: '4px' }}></Button>

                            </div>
                            <div className="grid grid-cols-1 md:grid-cols-12 gap-3 xl:gap-[1.250vw] pb-5">
                                {/* <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-3">
                                    <div>
                                        <div id={activate} className="bg-[#FFFFFF] rounded-lg box-shadow-1 radius4 p-4 xl:p-[0.833vw] top-5 lg:sticky fixed -left-96 lg:left-0 lg:overflow-hidden lg:h-auto z-10" data-aos="fade-up" data-aos-duration="800">
                                            <div className="flex justify-between text-[#101828] font-medium text-base tracking-[0.02em] xl:text-[0.932vw]">
                                                <p>Forms</p>
                                                <div className="xl:w-[10.058vw] md:w-[200px] custinput">
                                                    <span className="w-full p-input-icon-left">
                                                        <i className="gusd-search text-[#667085] mt-0" />
                                                        <InputText placeholder="Search" className="w-full" />
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="mt-4 h-[600px] xl:h-[38vw]  overflow-auto">

                                                <div className="bg-[#0F1E4C]  radius4 p-[16px] xl:p-[0.833vw]">
                                                    <h6 className="font-medium text-[16px] text-[#fff] xl:text-[0.833vw] mb-2">Weekly Absence Report-Classified</h6>
                                                    <div className="flex justify-between gap-2 xl:gap-[0.833vw] xl:mt-[0.833vw]">
                                                        <div className="flex items-center gap-1">
                                                            <div className="bg-[#EAEFFF] text-[16px] xl:text-[0.833vw] border border-[#99B2FF] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                                {weeklyAbsenceReportSubmitted === 0 ? 0 : weeklyAbsenceReportSubmitted}
                                                            </div>
                                                            <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Open</div>
                                                        </div>
                                                        <div className="flex items-center gap-1">
                                                            <div className="bg-[#D1FADF] text-[16px] xl:text-[0.833vw] border border-[#A6F4C5] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                                {weeklyAbsenceReportApproved === 0 ? 0 : weeklyAbsenceReportApproved}
                                                            </div>
                                                            <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Approved </div>
                                                        </div>
                                                        <div className="flex items-center gap-1">
                                                            <div className="bg-[#FEF3F2] text-[16px] xl:text-[0.833vw] border border-[#FEE4E2] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                                                                {weeklyAbsenceReportRejected === 0 ? 0 : weeklyAbsenceReportRejected}
                                                            </div>
                                                            <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Rejected</div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                <div className="relative z-10 col-span-12 lg:col-span-12" data-aos="fade-down" data-aos-duration="800">
                                    <div className="bg-[#fff] box-shadow-2 radius8 border border-[#E4E7EC]" >
                                        <div className="flex items-center justify-between p-[20px] xl:px-[1.250vw] xl:py-[0.990vw] border-b border-[#E4E7EC] ">

                                            <div className='flex items-center flex-col md:flex-row gap-2'>
                                                <p className="text-[22px] xl:text-[0.938vw] text-[#101828] font-medium">Weekly Absence Report-Classified</p>
                                                <Tag severity="" value={`${payollList.length} Request`} style={{ background: '#EFF8FF', color: '#0487C8', marginTop: "-3px" }} rounded></Tag>
                                            </div>
                                            <div className="flex gap-2 xl:gap-[0.990vw] items-center">
                                                {/*<Link to='/payroll/initiatepayrollreport' className="w-full text-center tableBtn blue radius8">
				<i className="gusd-pluse-circle mx-1.5 "></i> Initiate New Report</Link> */}
                                                <div className="relative dropcheck">
                                                </div>
                                                <Link to="" onClick={() => {
                                                    onToggle();
                                                }}> <i className="gusd-expand"></i></Link>
                                            </div>
                                        </div>
                                        <div className={payollList.length === 0 ? "datatableemptymessage arrowhide" : "payroll  arrowshow"}>
                                            <DataTable className="custpaginator custIcons custmBtnTable custTable" filters={filters} filterDisplay="row" sortOrder="-1" sortField="submittedOn" scrollable value={payollList} paginator rows={10} rowsPerPageOptions={[10, 20, 30]} responsiveLayout="scroll" loading={reportLoading}>
           <Column 
			style={{ minWidth: "3rem" }}
			header={<CheckboxHeader
        queries={queries.getInitiateClassifiedWeeklyAbsenceReport}
                                tableName={"getInitiateClassifiedWeeklyAbsenceReport"}
                                mutations={mutations.updateInitiateClassifiedWeeklyAbsenceReport}
        data={payollList} selectedRows={selectedRows} setSelectedRows={setSelectedRows} getMasterData={() => loadAbsenceReport()} setReportLoading={setReportLoading} loggedUserId={l2Authority}  />}
        body={(rowData) => <CheckboxColumn data={rowData} selectedRows={selectedRows} setSelectedRows={setSelectedRows} />}
      />
												<Column field="user_id" header="SL#" style={{ minWidth: '3rem', textAlign: 'center' }} body={(data, options) => options.rowIndex + 1}></Column>
                                                <Column field="workDuration" header="Week Duration" filter filterPlaceholder="Search" sortable style={{ minWidth: '5rem' }}></Column>
                                                <Column field="schoolName" header="School / Department Name" filter filterPlaceholder="Search" sortable></Column>
                                                <Column field="submittedOn" header="Submitted On" filter filterPlaceholder="Search" sortable style={{ minWidth: '5rem' }}  body={TimeSubmitted}></Column>
                                                <Column field="submittedBy" header="Submitted by" sortable filter filterPlaceholder="Search" style={{ minWidth: '7rem' }}></Column>
                                                <Column field="status" header="Status" body={TaskStatusSLA} filter filterElement={statusRowFilterTemplate} sortable style={{ minWidth: '8rem' }}></Column>
                                                <Column
                                                    field="assigneeName"
                                                    header="Assignee"
                                                    filter
                                                    filterPlaceholder="Search"
                                                    sortable
                                                    style={{ minWidth: "5rem" }}
                                                // body={TimeSubmitted}
                                                ></Column>
                                                <Column field="payroll_remark" header="Remarks" sortable style={{ minWidth: '5rem' }}></Column>
                                                <Column field="action" header="Action" align='center' body={alljobactionContent} style={{ minWidth: '6rem' }}></Column>
                                            </DataTable>
                                        </div>

                                        <Sidebar className="relative reports-popup" visible={visible} position={position} style={{ width: '50vw', minWidth: "20rem" }} onHide={() => setVisible(false)} draggable={false} resizable={false}>
                                            {reportDataLoad === true ?
                                                <div className="grid grid-cols-2 lg:grid-cols-12">
                                                    <div className="col-span-12 md:col-span-1 lg:col-span-8 bg-[#F5F6F7] h-auto">
                                                        <div className="p-5">
                                                            <div onClick={() => setVisible(false)} className="py-3"><Image
                                                                src={sideBar} alt="user" width="24" height="24" /></div>

                                                            <div className="text-[#113699] text-sm lg:text-[0.833vw] font-bold">Glendale Unified School District</div>
                                                            <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Weekly Absence Report - Classified form</div>

                                                            <div className="pt-3">
                                                                <div className="flex justify-between text-[#344054] text-[12px] py-[14px] px-[8px] border-b border-[#E4E7EC]">
                                                                    <div className="font-medium">School or Department </div>
                                                                    <div className="font-semibold ">{schoolName}</div>
                                                                </div>
                                                                <div className="flex justify-between text-[#344054] text-[12px] py-[14px] px-[8px] border-b border-[#E4E7EC]">
                                                                    <div className="font-medium">From </div>
                                                                    <div className="font-semibold ">{fromDate}</div>
                                                                </div>
                                                                <div className="flex justify-between text-[#344054] text-[12px] py-[14px] px-[8px] border-b border-[#E4E7EC]">
                                                                    <div className="font-medium">To </div>
                                                                    <div className="font-semibold ">{toDate}</div>
                                                                </div>
                                                                <div className="flex justify-between text-[#344054] text-[12px] py-[14px] px-[8px] border-b border-[#E4E7EC]">
                                                                    <div className="font-medium">Status </div>
                                                                    <div className="font-semibold ">{status}</div>
                                                                </div>
                                                                <div className="flex justify-between text-[#344054] text-[12px] py-[14px] px-[8px] border-b border-[#E4E7EC]">
                                                                    <div className="font-medium"> {payrollStatus === InitiateClassifiedWeeklyAbsenceReportStatus.PAYROLL_REJECTED ? "Rejected" : "Approved"} By </div>
                                                                    <div className="font-semibold ">{approvedBy}</div>
                                                                </div>
                                                                <div className="flex justify-between text-[#344054] text-[12px] py-[16px] px-[8px]">
                                                                    <div className="font-medium">Submitted By </div>
                                                                    <div className="font-semibold ">{submittedBy}</div>
                                                                </div>

                                                                <div className="flex justify-between text-[#344054] text-[12px] py-[16px] px-[8px]">
                                                                    <div className="font-medium">Comment </div>
                                                                    <div className="font-semibold ">{comment}</div>
                                                                </div>

                                                            </div>

                                                            <div className="py-3 emp-simple-tbl">

                                                                <DataTable value={reportEmployeeList} rowGroupMode="rowspan" groupRowsBy="employeeName" emptyMessage="No Absence" >
                                                                    <Column field="employeeName" header="Name of Employee"></Column>
                                                                    <Column field="absent_date" header="Dates Absent"></Column>
                                                                    <Column field="absent_code_id" header="Absent Codes"></Column>

                                                                    <Column field="partial_hour" body={(row) => {
                                                                        return (
                                                                            <h1>
                                                                                {
                                                                                    row.is_full_day ? "Full Day"
                                                                                        :
                                                                                        (row.partial_hour === null ? "0" : row.partial_hour) + "." + (row.partial_min === null ? "0" : Number(row.partial_min / 60).toFixed(2).slice(-2).padStart(2, '0')) + " Hr"} </h1>
                                                                        )

                                                                    }}
                                                                        header="Total Hours"></Column>
                                                                    <Column field="substitutedEmployeeName" header="Substitute"></Column>
                                                                </DataTable>

                                                            </div>

                                                            <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">
                                                                <div className="text-[#344054] font-medium text-[14px] pb-3">Absence Codes - Legends</div>
                                                                <div className="grid grid-cols-1 md:grid-cols-2">
                                                                    <div className="text-[#344054] text-[12px]">

                                                                        {absentCodeList.length > 0 && absentCodeList.slice(0, 7).map((item, index) => {
                                                                            return (<>
                                                                                <div className="grid grid-cols-5 pb-0.5">
                                                                                    <div className="col-span-1 font-semibold text-right"> {item.code}- </div>
                                                                                    <div className="col-span-4 pl-1">{item.name}</div>
                                                                                </div>
                                                                            </>
                                                                            )
                                                                        })}
                                                                    </div>

                                                                    <div className="text-[#344054] text-[12px]">
                                                                        {absentCodeList.length > 0 && absentCodeList.slice(7, 14).map((item, index) => {
                                                                            return (<>
                                                                                <div className="grid grid-cols-5 pb-0.5">
                                                                                    <div className="col-span-1 font-semibold text-right">{item.code}- </div>
                                                                                    <div className="col-span-4 pl-1">{item.name}</div>
                                                                                </div>

                                                                            </>
                                                                            )
                                                                        })}

                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#FFF] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">

                                                                <i className="mr-3 gusd-print-outline"></i><span className='printicon' onClick={handlePrint}>Print</span>

                                                                {/* ------------------------------------------------- */}
                                                                {/* /* print layout start */}
                                                                <div style={{ display: "none" }} >


                                                                    <div ref={componentRef} className='printTable' id='divname'>
                                                                        <table className="print-component w-full">
                                                                            <thead className="table-header">
                                                                                <tr>
                                                                                    <th>
                                                                                        <div>
                                                                                            {<>
                                                                                                <div style={{ marginTop: "20px" }}>
                                                                                                    <center className='font-bold text-[20px]' >GLENDALE UNIFIED SCHOOL DISTRICT
                                                                                                    </center>
                                                                                                    <center className='font-bold'>Weekly Absence Report - Classified
                                                                                                    </center>
                                                                                                    <p className='float-right'><span className='font-bold'>School or Dept. :- </span>{schoolName} </p><br />

                                                                                                    <p className='float-right'><span className='font-bold'>Period From :- </span>{fromDate}  </p><br />

                                                                                                    <p className='float-right'><span className='font-bold'>Period To :- </span>{toDate} </p><br />
                                                                                                    <p className='float-right'><span className='font-bold'>Submitted By :- </span>{submittedBy} </p>
                                                                                                </div>
                                                                                            </>}
                                                                                        </div>
                                                                                    </th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td>
                                                                                        {<div>
                                                                                            <br />
                                                                                            <p className='float-left' ><span className='font-bold'>Comment :- </span>{comment} </p>

                                                                                            {
                                                                                                reportDataLoad === true ?

                                                                                                    /*<table style={{ width: "100%", marginTop: "80px" }}>
                                                                                                        <thead>
                                                                                                        <tr>
                                                                                                            <th style={{ border: "1px solid #d0d0d0", padding: "5px" }} >Name of Employee</th>
                                                                                                            <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Dates Absent</th>
                                                                                                            <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Absent Code</th>
                                                                                                            <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Total Hours</th>
                                                                                                            <th style={{ border: "1px solid #d0d0d0", padding: "5px" }}>Substitute</th>
                        
                                                                                                        </tr>
                                                                                                        </thead>
                                                                                                        {
                                                                                                            reportEmployeeList.map((item) => {
                                                                                                                return (
                                                                                                                    <tr className='text-center'>
                                                                                                                        <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.employeeName}</td>
                                                                                                                        <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.absent_date}</td>
                                                                                                                        <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.absent_code_id}</td>
                                                                                                                        {item.is_full_day ?
                                                                                                                            <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{"Full Day"}</td>
                                                                                                                            :
                        
                        
                                                                                                                            <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.partial_hour}.{(item.partial_min === null ? "0" : Number(item.partial_min / 60 * 100).toFixed(0))} Hr </td>
                                                                                                                        }
                                                                                                                        <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>{item.substitutedEmployeeName}</td>
                                                                                                                    </tr>
                                                                                                                );
                                                                                                            })
                                                                                                        }
                        
                                                                                                    </table> */



                                                                                                    <div className="py-3 mt-10  my-custom-datatable">
                                                                                                        <DataTable value={reportEmployeeList} rowGroupMode="rowspan" groupRowsBy="employeeName" emptyMessage="No Absence" >
                                                                                                            <Column field="employeeName" header="Name of Employee"></Column>
                                                                                                            <Column field="absent_date" header="Dates Absent"></Column>
                                                                                                            <Column field="absent_code_id" header="Absent Codes"></Column>

                                                                                                            <Column field="partial_hour" body={(row) => {
                                                                                                                return (
                                                                                                                    <h1>
                                                                                                                        {
                                                                                                                            row.is_full_day ? "Full Day"
                                                                                                                                :
                                                                                                                                (row.partial_hour === null ? "0" : row.partial_hour) + "." + (row.partial_min === null ? "0" : Number(row.partial_min / 60).toFixed(2).slice(-2).padStart(2, '0')) + " Hr"} </h1>
                                                                                                                )

                                                                                                            }}
                                                                                                                header="Total Hours"></Column>
                                                                                                            <Column field="substitutedEmployeeName" header="Substitute"></Column>
                                                                                                        </DataTable>
                                                                                                    </div>


                                                                                                    : <div className="card flex justify-content-center align-item-center position-absolute top-50 left-50">
                                                                                                        <ProgressSpinner />
                                                                                                    </div>
                                                                                            }


                                                                                            {reportDataLoad === true && reportEmployeeList.length === 0 ?
                                                                                                <div className='mt-8 font-bold' >No Absence
                                                                                                </div>
                                                                                                : null
                                                                                            }


                                                                                            <div className='mt-8 font-bold' >ABSENCE CODES
                                                                                            </div>

                                                                                            <table style={{ width: "100%", marginTop: "20px" }}>
                                                                                                <tr className='text-[12px]'>
                                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>B - Bereavement</td>
                                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>NA - Personal (Not Approved)</td>
                                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>S - Suspension</td>
                                                                                                </tr>
                                                                                                <tr className='text-[12px]'>
                                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>D - District Approved</td>
                                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>OU - Other Unpaid</td>
                                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>V - Vacation</td>
                                                                                                </tr>
                                                                                                <tr className='text-[12px]'>
                                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>I - Illness</td>
                                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>PA - Personal (Approved)</td>
                                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>W - Witness (District)</td>
                                                                                                </tr>
                                                                                                <tr className='text-[12px]'>
                                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>J - Jury Duty</td>
                                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>WC - Worker's Compensation</td>
                                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>DC - District Covid</td>
                                                                                                </tr>
                                                                                                <tr className='text-[12px]'>
                                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>L - Last Day Worked</td>
                                                                                                    <td style={{ border: "1px solid #d0d0d0", padding: "5px" }}>PN - Personal Necessity</td>
                                                                                                </tr>

                                                                                            </table>

                                                                                            <p className='float-right font-bold'>
                                                                                                <span>{'Submitted by:'}</span></p><br />
                                                                                            <h2 className='float-right'>{submittedBy ? submittedBy : '-'} {submittedByDate ? submittedByDate : null} </h2><br />

{formHistory.length === 0?
<>
																								<p className='float-right font-bold'>
                                                                                                <span>{'Approved by:'}</span>
                                                                                            </p> <br />
                                                                                            <h2 className='float-right'>{approvedBy ? approvedBy : null} {approverDate ? approverDate : null} </h2><br />
																						<h2 className='float-right'>{payrollBy ? payrollBy : null} {payrollDate ? payrollDate : null}</h2> 




</>
:
<>
                                        
{
	formHistoryApp && formHistoryApp.map((data1, index) => {
		return (
			<>
			{index === 0?
			<><p className='float-right font-bold'><span>{'Approved by:'}</span></p> <br /></>
			: null 
			}
				{data1.status === "Approved" ?
				
				<>
				
					<h2 className='float-right'>{data1.empName ? data1.empName : null}
						{data1?.date ? data1?.date : null}
						
					</h2><br />
					</>
					: null}
			</>
		)
	})
}


{
formHistoryClosed && formHistoryClosed.map((data1, index) => {
	return (
		<>
		
			{data1.status === "Closed" ?
			
			<>
			
			
					<h2 className='float-right'>{data1.empName ? data1.empName : null}
						{data1?.date ? data1?.date : null}
						
					</h2><br />
					</>
				: null}
		</>
	)
})
}


{
formHistoryRej && formHistoryRej.map((data1, index) => {
	return (
		<>
		{index === 0 ?
			<><p className='float-right font-bold'><span>{'Rejected by:'}</span></p> <br /></>
			: null 
			}
			{data1.status === "Rejected" ?
			
			<>
			
					<h2 className='float-right'>{data1.empName ? data1.empName : null}
						{data1?.date ? data1?.date : null}
						
					</h2><br />
					
				</>
				: null}
		</>
	)
})
}


{
formHistoryResub && formHistoryResub.map((data1, index) => {
	return (
		<>
		{index === 0  ?
			<><p className='float-right font-bold'><span>{'Resubmit by:'}</span></p> <br /></>
			: null 
			}
			{data1.status === WAR_CLASSIFIED_STATUS.RESUBMITTEDBYINT ?
			
			<>
			
					<h2 className='float-right'>{data1.empName ? data1.empName : null}
						{data1?.date ? data1?.date : null}
						
					</h2><br />
					</>
				: null}
		</>
	)
})
}


</>
}

                                                                                        </div>}
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                            {/* <tfoot className="table-footer">
                                                            <tr>
                                                                <td>
                                                                    {`Page Number ${1}`}
                                                                </td>
                                                            </tr>
                                                        </tfoot> */}
                                                                        </table>
                                                                    </div>

                                                                </div>
                                                                {/* print layout end */}
                                                                {/* ------------------------------------------------- */}


                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-span-12 md:col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">

                                                        <div className="p-5">
                                                            <div className="text-[#344054] text-[16px] font-medium py-3 mb-5">Form History</div>

                                                            <div className="card custTable">

                                                                <Timeline value={formHistory}
                                                                    opposite={(item) => <Tag
                                                                        severity={approveStatusOptions(item)} className="mr-2 relative top-[-5px]"
                                                                        value={item.status}></Tag>} content={(item, i) => <div className="relative top-[-10px]">
                                                                            <div className="text-[#667085] text-[12px] ml-2">Step {i + 1}</div>
                                                                            <small className="xl:text-[0.729vw] text-[14px] font-semibold text-[#113699] leading-tight ml-2">{item.empTitle}</small>
                                                                            <div className="text-color-secondary text-xs ml-2">{item.empName}</div>
                                                                            <div className="text-color-secondary text-[9px] ml-2">{item.date}</div>

                                                                        </div>} />

                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/*
                                                <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">
                                                    <div className="p-5">
                                                        <div className="text-[#344054] text-[16px] font-medium py-3">Form History</div>
                                                        {
                                                            reportLogList.map((item, index) => {
                                                                return (
                                                                    <div className="flex items-start justify-between gap-2 py-2">
                                                                        <Image src={item.ProfilePic} alt="user" width="32" height="32" />
                                                                        <div className="">
                                                                            <div className="flex justify-between">
                                                                                <div>
                                                                                    <div className="text-[#344054] font-semibold text-[14px]">{item.name}</div>
                                                                                    <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                                                                        <i className="mr-1 gusd-commented"></i>
                                                                                        <span>Commented on parties Tab</span>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="text-[#344054] text-[12px]">{item.dateTime}</div>
                                                                            </div>
                                                                            <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">{item.comment}</div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                */}
                                                </div>


                                                : <div className="card flex justify-content-center align-item-center position-absolute top-50 left-50">
                                                    <ProgressSpinner />
                                                </div>
                                            }
                                        </Sidebar>

                                    </div>

                                    <Sidebar visible={visibleRight} position="right" onHide={() =>
                                        setVisibleRight(false)} style={{ width: '55vw' }} className="customesidebar1 responsivepoup editpopupres">
                                        {reportDataLoad === true ?
                                            <Editpopup popupstate={() => setVisibleRight(false)}
                                                fromDate={fromDate}
                                                toDate={toDate}
                                                schoolName={schoolName}
                                                reportEmployeeList={reportEmployeeList}
                                                reportEmployeeLoading={reportDataLoad}
                                                status={status}
                                                reportId={reportId}
                                                bindList={() => loadAbsenceReport()}
                                                handlePrint={() => handlePrint()}
                                                type={"Payroll"}
                                                comment={comment}

                                                submittedBy={submittedBy}
                                                submittedByDate={submittedByDate}
                                                approvedBy={approvedBy}
                                                approverDate={approverDate}
                                                payrollBy={payrollBy}
                                                payrollDate={payrollDate}
                                                noAbsence={noAbsence}

                                                // events={events}
                                                approveStatusOptions={approveStatusOptions}
                                            />
                                            : <div className="card flex justify-content-center align-item-center position-absolute top-50 left-50">
                                                <ProgressSpinner />
                                            </div>
                                        }
                                    </Sidebar>
                                </div>
                            </div>
                        </div>
                    </Layout>
                )}
            </ReactFullscreen>
        </>

    ) : (
        <Login sessionExpired={1} />
    );
}